module.exports = {"id":"175895","name":"Vadis Odjidja-Ofoe","rating":"78","photo":"./data/images/photos/4/175895.png","club":{"name":"Olympiakos CFP","logo":"./data/images/clubs/OlympiakosCFP.png"},"positions":["MC","MDC","MOC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/VadisOdjidja-Ofoe0.json
// module id = 4216
// module chunks = 0